
// ... first row length is used as the basis.
//     The rest of the rows should have lesser or equal number of items.
export default (uxMaxColumnsPerRow, list) => {
  let spr = list[0].length;

  list.slice(1).forEach((row) => {
    const len = row.length;
    if (len > spr) {
      console.error(
        `items per row '${len}' > base number of rows '${spr}'...\n`,
        list
      );
    }
  });

  return uxMaxColumnsPerRow / spr;
};



// WEBPACK FOOTER //
// ./src/lib/uxColWidthForItemsPerRow.js